(function () {
  const CLONE_ROUNDS = 5;
  function init(root) {
    if (!root || root.dataset.lmInit) return;
    root.dataset.lmInit = "1";
    const track = root.querySelector(".lm-track");
    const prev = root.querySelector(".lm-prev");
    const next = root.querySelector(".lm-next");
    const img = root.querySelector(".lm-img");
    const title = root.querySelector(".lm-title");
    const price = root.querySelector(".lm-price");
    const link = root.querySelector(".lm-link");
    const variantsBox = root.querySelector(".lm-variants");
    const dotsWrap = root.querySelector(".lm-dots");
    let originals = Array.from(track.querySelectorAll(".lm-slide"));
    const N = originals.length;
    if (!N) return;
    // Limpia clones
    Array.from(track.querySelectorAll(".lm-clone")).forEach(n => n.remove());
    // Marca índice real
    originals.forEach((s, i) => (s.dataset.real = i));
    const cloneOf = (s) => {
      const c = s.cloneNode(true);
      c.classList.add("lm-clone");
      c.dataset.real = s.dataset.real;
      return c;
    };
    // Clones izquierda (reversa) x2
    const left = [];
    for (let r = 0; r < CLONE_ROUNDS; r++) {
      originals.slice().reverse().forEach(s => left.push(cloneOf(s)));
    }
    // Clones derecha (normal) x2
    const right = [];
    for (let r = 0; r < CLONE_ROUNDS; r++) {
      originals.forEach(s => right.push(cloneOf(s)));
    }
    left.forEach(c => track.insertBefore(c, track.firstChild));
    right.forEach(c => track.appendChild(c));
    const slides = Array.from(track.querySelectorAll(".lm-slide"));
    // ---- Dots ----
    let dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      for (let i = 0; i < N; i++) {
        const d = document.createElement("span");
        d.className = "lm-dot";
        d.dataset.real = i;
        dotsWrap.appendChild(d);
      }
      dots = Array.from(dotsWrap.children);
    }
    // ---- Utils ----
    function pauseAll() {
      slides.forEach(el => {
        el.classList.remove("active");
        const v = el.querySelector("video");
        if (v) v.pause();
      });
    }
    function getCentered() {
      const rect = track.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      let best = null;
      let bestDist = Infinity;
      slides.forEach(el => {
        const r = el.getBoundingClientRect();
        const c = r.left + r.width / 2;
        const d = Math.abs(c - centerX);
        if (d < bestDist) {
          bestDist = d;
          best = el;
        }
      });
      return best;
    }
    function stepWidth() {
      const a = slides[0];
      const b = slides[1] || a;
      const ra = a.getBoundingClientRect();
      const rb = b.getBoundingClientRect();
      return Math.abs((rb.left + rb.width / 2) - (ra.left + ra.width / 2));
    }
    function setDots(real) {
      dots.forEach(d => d.classList.remove("active"));
      const a = dots.find(d => Number(d.dataset.real) === real);
      if (a) a.classList.add("active");
    }
    async function loadColorVariants(handle) {
      if (!variantsBox || !handle) return;
      try {
        const res = await fetch(`/products/${handle}.js`);
        const product = await res.json();
        variantsBox.innerHTML = "";
        const colorIndex = product.options.findIndex(o =>
          o.toLowerCase().includes("color") || o.toLowerCase().includes("colour")
        );
        if (colorIndex === -1) return;
        const seen = {};
        product.variants.forEach(v => {
          const color = v.options[colorIndex];
          if (!seen[color]) seen[color] = v;
        });
        Object.values(seen).forEach((variant, i) => {
          const sw = document.createElement("div");
          sw.className = "lm-variant" + (variant.available ? "" : " disabled");
          sw.textContent = variant.options[colorIndex];
          sw.onclick = () => {
            variantsBox.querySelectorAll(".lm-variant").forEach(b => b.classList.remove("active"));
            sw.classList.add("active");
            link.href = `${product.url}?variant=${variant.id}`;
            price.textContent = (variant.price / 100).toLocaleString("es-PE", {
              style: "currency",
              currency: "PEN"
            });
          };
          if (i === 0 && variant.available) {
            sw.classList.add("active");
            link.href = `${product.url}?variant=${variant.id}`;
          }
          variantsBox.appendChild(sw);
        });
      } catch (e) {
        console.warn("Variant load error", e);
      }
    }
    function applyActive() {
      const s = getCentered();
      if (!s) return;
      const real = Number(s.dataset.real);
      pauseAll();
      s.classList.add("active");
      const v = s.querySelector("video");
      if (v) v.play().catch(() => {});
      img.src = s.dataset.productImage || "";
      title.textContent = s.dataset.productTitle || "";
      price.textContent = s.dataset.productPrice || "";
      link.href = s.dataset.productUrl || "#";
      setDots(real);
      loadColorVariants(s.dataset.productHandle);
    }
    // ---- Scroll infinito ----
    function fixInfinite() {
      const centered = getCentered();
      if (!centered) return;
      const idx = slides.indexOf(centered);
      const w = stepWidth();
      const total = slides.length;
      const leftLimit = N;
      const rightLimit = total - N - 1;
      if (idx < leftLimit) {
        track.scrollLeft += N * w;
      } else if (idx > rightLimit) {
        track.scrollLeft -= N * w;
      }
    }
    // ---- Events ----
    let ticking = false;
    track.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        fixInfinite();
        applyActive();
        ticking = false;
      });
    });
    slides.forEach(s => {
      s.addEventListener("click", () => {
        s.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      });
    });
    function go(dir) {
      const w = stepWidth();
      track.scrollBy({ left: dir * w, behavior: "smooth" });
    }
    if (next) next.onclick = () => go(1);
    if (prev) prev.onclick = () => go(-1);
    // ---- Start en A real ----
    requestAnimationFrame(() => {
      const w = stepWidth();
      track.scrollLeft = w * (CLONE_ROUNDS * N);
      applyActive();
      fixInfinite();
    });
  }
  function boot() {
    document.querySelectorAll("[data-lm-shoppable]").forEach(init);
  }
  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
